import _ from "lodash";
/**--external-- */
import React from "react";

/**--internal-- */
import CheckListContainer from "UIComponents/CheckListContainer";
import Listview from "UIComponents/Listview";

/**--relative-- */
import Field from "../Field";
import { getChecklistValue } from "../FieldUtils";
import {
  previewModeStyles,
  editModeStyles,
  emptyLabelStyle,
} from "./FieldChecklistStyles";

class FieldChecklist extends Field {
  renderPreviewContent = () => {
    let { options } = this.props;
    const {
      listItemStyle,
      checklistContainerStyle,
      checkBoxLabelStyles,
    } = previewModeStyles;

    options = _.map(options, node => ({
      ...node,
      value: node.id,
      isCheckboxLabelEmpty: _.isEmpty(node.label),
      label: _.isEmpty(node.label)
        ? this.props.noLabelAlertMessage
        : node.label,
    }));

    return (
      <CheckListContainer
        customToggleFn={_.noop}
        mode="edit"
        options={options}
        emptyLabelStyle={emptyLabelStyle}
        checkListContainerStyle={checklistContainerStyle}
        listItemStyle={listItemStyle}
        CheckBoxLabelStyles={checkBoxLabelStyles}
      />
    );
  };

  renderView = () => {
    const { fieldObj, emptyText, customTextStyle } = this.props;

    const value = getChecklistValue({ valueObj: fieldObj });

    return (
      <Listview
        value={value}
        emptyText={emptyText}
        mode="view"
        customTextStyle={customTextStyle}
      />
    );
  };

  renderEdit = () => {
    const { plannerElementSet, value, emptyText } = this.props;
    const { nodes } = plannerElementSet;
    const {
      listItemStyle,
      checklistContainerStyle,
      checkBoxLabelStyles,
    } = editModeStyles;

    const options = _.map(nodes, node => ({
      ...node,
      value: node.id,
    }));

    return (
      <CheckListContainer
        mode="edit"
        emptyText={emptyText}
        value={value ? value : []}
        options={options}
        checkListContainerStyle={checklistContainerStyle}
        listItemStyle={listItemStyle}
        CheckBoxLabelStyles={checkBoxLabelStyles}
        updateInputField={value => {
          this.updateValue(value, { nodes });
        }}
      />
    );
  };
}

export default FieldChecklist;
FieldChecklist.displayName = "FieldChecklist";
